exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".docusign-status-compact>div[data-v-518dd209]{gap:.5rem}.docusign-status-compact p[data-v-518dd209]{margin:0;padding:0}", ""]);

// exports
